module.exports = __webpack_public_path__ + "img/IMÁGENES CLÍNICAS KU1 3.5de42657.png";